'use strict';

import { htmlSearch } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const searchToggle = document.querySelector('.header__search-toggle');
  const searchForm = document.querySelector('.search-form');
  const searchInput = document.querySelector('.search-form__input');
  const searchSubmit = document.querySelector('.search-form__submit');
  const searchResult = document.querySelector('.search-form__list');

  const menu = document.querySelector('.menu');
  const menuToggle = document.querySelector('.header__menu-toggle');
  let flagClickSearch = false;

  let eventFocus = new Event('focus');

  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      if (!searchForm.closest('.search-form--opened')) {
        if(!document.body.closest('.no-scroll')) {
          searchForm.classList.add('search-form--opened');
          searchInput.dispatchEvent(eventFocus);
          return false;
        }

        document.body.classList.remove('no-scroll');
        menu.classList.remove('menu--opened');
        menuToggle.classList.remove('header__menu-toggle--opened');
        flagClickSearch = true;
      } else {
        searchForm.classList.remove('search-form--opened');
        flagClickSearch = false;
      }
    });
  }

  menu.addEventListener('transitionend', (e) => {
    if (flagClickSearch && !menu.closest('.menu--opened') && e.propertyName === 'opacity') {
      searchForm.classList.add('search-form--opened');
    }
  });

  if(searchInput) {
    searchInput.addEventListener('focus', () => {
      searchSubmit.classList.add('search-form__submit--active');

      if(searchInput.value) {
        searchResult.classList.add('search-form__list--open');
      }
    });

    searchInput.addEventListener('blur', () => {
      searchSubmit.classList.remove('search-form__submit--active');
    });
  }

  let timer;
  searchInput.addEventListener('input', (e) => {
    clearTimeout(timer);
    if(e.target.value === '') {
      searchResult.classList.remove('search-form__list--open');
      return false;
    }

    timer = setTimeout(() => {
      let formData = new FormData();
      formData.append('action', 'search');
      formData.append('search', e.target.value);

      fetch(themeVar.url, {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if(data.status == 'fail') {
          searchResult.classList.remove('search-form__list--open');
          return false;
        }

        htmlSearch(data.search, searchResult);
        searchResult.classList.add('search-form__list--open');
      });
    }, 700);
  })

  searchForm.addEventListener('submit', (e) => e.preventDefault());

  document.addEventListener('click', (e) => {
    if( !e.target.closest('.search-form') ) {
      searchResult.classList.remove('search-form__list--open');
    }
  })

  let widthWindow = window.outerWidth;
  window.addEventListener('resize', () => {
    if(widthWindow !== window.outerWidth) {
      searchForm.classList.remove('search-form--opened');
      flagClickSearch = false;
    }
  });
});